/**
 * Dropio Beta — supported countries & cities.
 *
 * FUTURE-READY: To support a new country, add an entry below.
 * No UI/component code needs to change. Backend validation also reads
 * from /api/public/locations so adding a country here AND in
 * backend/locations.py is the only change required.
 *
 * Country `code` must be a unique stable identifier (ISO-2 preferred).
 * City `value` is the canonical name stored in the database — keep this
 * stable even if `label` changes.
 */
export const SUPPORTED_LOCATIONS = [
  {
    code: 'AU',
    name: 'Australia',
    flag: '🇦🇺',
    cities: [
      { value: 'Melbourne', label: 'Melbourne' },
      { value: 'Sydney', label: 'Sydney' },
      { value: 'Brisbane', label: 'Brisbane' },
      { value: 'Perth', label: 'Perth' },
      { value: 'Adelaide', label: 'Adelaide' },
      { value: 'Canberra', label: 'Canberra' },
      { value: 'Gold Coast', label: 'Gold Coast' },
    ],
  },
  {
    code: 'BD',
    name: 'Bangladesh',
    flag: '🇧🇩',
    cities: [
      { value: 'Dhaka', label: 'Dhaka' },
      { value: 'Chattogram', label: 'Chattogram (Chittagong)' },
      { value: 'Sylhet', label: 'Sylhet' },
      { value: 'Khulna', label: 'Khulna' },
      { value: 'Rajshahi', label: 'Rajshahi' },
      { value: 'Barishal', label: 'Barishal' },
      { value: 'Rangpur', label: 'Rangpur' },
    ],
  },
];

export const COUNTRY_NAMES = SUPPORTED_LOCATIONS.map((c) => c.name);

export const getCitiesForCountry = (countryName) => {
  const entry = SUPPORTED_LOCATIONS.find((c) => c.name === countryName);
  return entry ? entry.cities : [];
};

export const getCountryByName = (countryName) =>
  SUPPORTED_LOCATIONS.find((c) => c.name === countryName) || null;

export const isValidCountry = (countryName) =>
  SUPPORTED_LOCATIONS.some((c) => c.name === countryName);

export const isValidCity = (countryName, cityName) => {
  const cities = getCitiesForCountry(countryName);
  return cities.some((c) => c.value === cityName);
};
